// extracted by mini-css-extract-plugin
export default {"-large":"Tz4nbfasRYAXY4vHVA0x","onMyDesignHeading":"pzeSop5Zp3ZuF0Es0XUg"};